<template>
  <server-log-table kind="transactionLog" />
</template>

<script>
import ServerLogTable from '../LogPages/ServerLogTable.vue'

export default {
  components: { ServerLogTable },
}
</script>
